<!-- 微信通知自动换绑手机号页面 -->
<template>
  <div class="content">
    <!-- 加载状态 -->
    <div class="loading-container" v-if="isLoading">
      <van-loading size="24px" text-color="#0094ff" color="#0094ff" vertical>用户信息正在初始化中...</van-loading>
    </div>

    <!-- 用户信息 -->
    <div class="user-info-section" v-if="userInfo.gzh_openid && !isLoading">
      <div class="section-title">
        <h2>个人信息</h2>
        <p>部分关联推送场景需要用到您的基本信息</p>
      </div>

      <div class="form-container">
        <div class="form-item">
          <label class="form-label">关注状态</label>
          <div class="status-wrapper">
            <div
              class="status-indicator"
              :class="{ 'subscribed': userInfo.subscribe, 'unsubscribed': !userInfo.subscribe }"
              @click="handleStatusClick"
            >
              <span class="status-icon">{{ userInfo.subscribe ? '✓' : '✗' }}</span>
              <span class="status-text">{{ userInfo.subscribe ? '已关注公众号' : '未关注公众号-不能接收提醒' }}</span>
            </div>
          </div>
        </div>

        <div class="form-item">
          <label class="form-label">公众号通知提醒</label>
          <div class="switch-wrapper">
            <div class="switch-info">
              <span class="switch-text">{{ userInfo.is_send === 0 ? '已开启' : '已关闭' }}</span>
              <span class="switch-desc">{{ userInfo.is_send === 0 ? '将接收公众号推送消息' : '不会接收公众号推送消息' }}</span>
            </div>
            <div
              class="custom-switch"
              :class="{ 'is-active': userInfo.is_send === 0 }"
              @click="toggleNotification"
            >
              <div class="switch-button"></div>
            </div>
          </div>
        </div>

        <div class="form-item">
          <label class="form-label">我的公众号OpenID</label>
          <div class="input-wrapper">
            <input
              class="form-input"
              ref="openidInput"
              placeholder="我的openid"
              v-model="userInfo.gzh_openid"
              readonly
            />
            <button @click="handleCopy" class="copy-btn">复制</button>
          </div>
        </div>

        <div class="form-item">
          <label class="form-label">姓名</label>
          <div class="input-wrapper">
            <input
              class="form-input"
              placeholder="联系客服修改"
              v-model="userInfo.user_name"
              maxlength="20"
              disabled
            />
          </div>
        </div>

        <div class="form-item">
          <label class="form-label">手机号</label>
          <div class="input-wrapper">
            <input
              class="form-input"
              placeholder="联系客服修改"
              v-model="userInfo.phone"
              type="tel"
              maxlength="11"
              disabled
            />
          </div>
        </div>

        <!-- <div class="button-group">
          <button @click="handleSave" class="save-btn">保存信息</button>
        </div>-->
      </div>
    </div>

    <aside
      class="aside_box"
      ref="topSection"
      v-if="userInfo.gzh_openid && !userInfo.subscribe && !isLoading"
    >
      <div class="title">
        <h1>多样性的微信通知服务</h1>
        <p>{{ userInfo.account_name }}官方公众号</p>
        <div class="qr-code-container">
          <img :src="userInfo.gzh_img" alt srcset class="img-box animated-qr" />
          <div class="scan-line"></div>
        </div>
        <p class="qr-code-text">长按识别二维码关注</p>
      </div>
    </aside>
    <aside class="aside_box" ref="topSection" v-else-if="!isLoading">
      <div class="title">
        <h1>多样性的微信通知服务</h1>
        <p>技术支持</p>
        <div class="qr-code-container">
          <img :src="require('../image/wx.jpg')" alt srcset class="img-box animated-qr" />
          <div class="scan-line"></div>
        </div>
        <p class="qr-code-text">长按识别二维码-获取技术支持</p>
      </div>
    </aside>

    <!-- <footer>
      <div>
        © 公司名称｜沪ICP备xxxx
        <br />Copyright © 2024 All Rights Reserved.
      </div>
    </footer>-->
  </div>
</template>

<script>
// Dialog
import { Toast, Dialog } from "vant";
import { update, login } from "@/services/login";
import { getUrlParams } from "@/utils/getUrlParams.js";
// import wx from "@/assets/js/jweixin-1.3.2.js";
// 通过persisted属性判断是否存在 BF Cache
// window.addEventListener("pageshow", function(e) {
//   if (e.persisted) {
//     location.reload();
//   }
// });
export default {
  data() {
    return {
      userInfo: {
        gzh_openid: "",
        name: "",
        phone: "",
        is_send: 0 // 0开启，1关闭
      },
      startY: 0,
      currentY: 0,
      isPulling: false,
      pullDistance: 0,
      isLoading: false
    };
  },
  async created() {
    let { appid, openid, phone, user_name } = this.$route.query;
    // 从 cookie 中读取 gzh_openid
    const gzh_openid = this.getCookie("gzh_openid") || null;
    const code = getUrlParams(window.location.href)?.code || null; //公众号登录完成才会返回该字段

    if (!appid) {
      console.log("缺少appid");
      Dialog.alert({
        title: "提示",
        message: "缺少appid",
        confirmButtonText: "联系技术人员",
        showCancelButton: false
      }).then(() => {
        this.$router.replace("/");
      });
      return;
    }
    // 如果有 appid 和 code，说明是从 Login 页面跳转过来的，需要调用 login API
    this.isLoading = true;
    try {
      const result = await login({
        appid,
        openid,
        code,
        phone,
        user_name,
        gzh_openid
      });

      this.isLoading = false;

      if (result.code == 200) {
        // 登录成功，更新用户信息
        this.userInfo = {
          ...result.data
        };
        // 将 gzh_openid 保存到本地 cookie，后续接口调用会用到
        if (result.data.gzh_openid) {
          this.setCookie("gzh_openid", result.data.gzh_openid, 7);
        }
      } else {
        // 登录失败或其他错误
        Dialog.confirm({
          title: "提示",
          message:
            result.code == 201
              ? result.message || "登录失败,联系技术人员"
              : "当前登录信息已失效，请重新登录！",
          confirmButtonText: "重新登录",
          cancelButtonText: "联系技术人员"
        })
          .then(() => {
            //清除gzh_openid的cookie信息
            this.deleteCookie("gzh_openid");
            // 点击"重新登录"
            this.$router.replace(`/login?appid=${appid}`);
          })
          .catch(() => {
            // 点击"联系技术人员"
            this.$router.replace("/");
          });
      }
    } catch (error) {
      this.isLoading = false;
      console.error("登录错误:", error);
      //清除gzh_openid的cookie信息
      this.deleteCookie("gzh_openid");
      Dialog.alert({
        title: "提示",
        message: "登录失败，请重试",
        confirmButtonText: "确定",
        showCancelButton: false
      }).then(() => {
        this.$router.replace(`/login?appid=${appid}`);
      });
    }
  },

  mounted() {
    // 监听下拉刷新事件
    this.addPullToRefreshListeners();
  },

  beforeDestroy() {
    // 清理下拉刷新事件监听器
    this.removePullToRefreshListeners();
  },

  methods: {
    // 设置 Cookie
    setCookie(name, value, days) {
      const expires = new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = `${name}=${encodeURIComponent(
        value
      )};expires=${expires.toUTCString()};path=/`;
    },

    // 获取 Cookie
    getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
          return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
      }
      return null;
    },

    // 删除 Cookie
    deleteCookie(name) {
      this.setCookie(name, "", -1);
    },

    // 点击关注状态处理
    handleStatusClick() {
      if (!this.userInfo.subscribe) {
        // 滚动到顶部提醒用户扫码关注
        this.scrollToTop();
        Toast("请扫描上方二维码关注公众号");
      }
    },

    // 滚动到顶部
    scrollToTop() {
      this.$refs.topSection.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    },

    // 切换通知开关
    toggleNotification() {
      const newValue = this.userInfo.is_send === 0 ? 1 : 0;
      console.log("切换通知开关", newValue);
      // 调用更新接口
      update({
        gzh_openid: this.userInfo.gzh_openid,
        // user_name: this.userInfo.name,
        // phone: this.userInfo.phone,
        is_send: newValue
      })
        .then(res => {
          if (res.code == 200) {
            // 接口成功后才更新视图，使用 $set 确保响应式
            this.$set(this.userInfo, "is_send", newValue);
            Toast(newValue === 0 ? "已开启公众号通知" : "已关闭公众号通知");
          } else {
            Toast.fail("更新通知设置失败");
          }
        })
        .catch(err => {
          console.error("更新失败:", err);
          Toast.fail("更新通知设置失败");
        });
    },

    // 刷新按钮点击事件
    handleRefresh() {
      Dialog.confirm({
        title: "确认操作",
        message: "确定要重新登录吗？",
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          // 返回登录页
          this.$router.push("/login");
        })
        .catch(() => {
          // 用户取消
        });
    },

    // 添加下拉刷新监听器
    addPullToRefreshListeners() {
      const content = document.querySelector(".content");
      if (content) {
        content.addEventListener("touchstart", this.handleTouchStart, {
          passive: false
        });
        content.addEventListener("touchmove", this.handleTouchMove, {
          passive: false
        });
        content.addEventListener("touchend", this.handleTouchEnd, {
          passive: false
        });
      }
    },

    // 移除下拉刷新监听器
    removePullToRefreshListeners() {
      const content = document.querySelector(".content");
      if (content) {
        content.removeEventListener("touchstart", this.handleTouchStart);
        content.removeEventListener("touchmove", this.handleTouchMove);
        content.removeEventListener("touchend", this.handleTouchEnd);
      }
    },

    // 触摸开始
    handleTouchStart(e) {
      if (window.scrollY <= 0) {
        this.startY = e.touches[0].clientY;
        this.isPulling = false;
        this.pullDistance = 0;
      }
    },

    // 触摸移动
    handleTouchMove(e) {
      if (window.scrollY <= 0) {
        this.currentY = e.touches[0].clientY;
        const pullDistance = this.currentY - this.startY;

        if (pullDistance > 0) {
          e.preventDefault();
          this.isPulling = true;
          this.pullDistance = Math.min(pullDistance, 100);

          // 显示下拉提示
          if (this.pullDistance > 60) {
            // 可以添加下拉刷新的视觉反馈
          }
        }
      }
    },

    // 触摸结束
    handleTouchEnd() {
      if (this.isPulling && this.pullDistance > 60) {
        // 触发刷新
        this.triggerRefresh();
      }

      this.isPulling = false;
      this.pullDistance = 0;
      this.startY = 0;
      this.currentY = 0;
    },

    // 触发刷新
    triggerRefresh() {
      // Toast("刷新中...");
      // setTimeout(() => {
      //   // 重新获取用户信息或刷新页面
      //   location.reload();
      // }, 500);
    },

    // goBack() {
    //   // eslint-disable-next-line no-undef
    //   wx.miniProgram.navigateBack(); //返回小程序上一个页面
    // },

    /* 复制 */
    async handleCopy() {
      try {
        const input = this.$refs.openidInput;
        const textToCopy = input.value;
        // 尝试使用 Clipboard API
        try {
          await navigator.clipboard.writeText(textToCopy);
        } catch (err) {
          // 如果 Clipboard API 失败，回退到 document.execCommand('copy')
          input.select();
          document.execCommand("copy");
          input.blur();
        }

        Toast("复制成功");
      } catch (err) {
        Toast.fail("复制失败");
        console.log("复制失败:", err);
      }
    },

    /* 保存用户信息 */
    async handleSave() {
      // 验证输入
      if (!this.userInfo.user_name?.trim()) {
        Toast("请输入姓名");
        return;
      }

      if (!this.userInfo.phone?.trim()) {
        Toast("请输入手机号");
        return;
      }

      // 验证手机号格式
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.userInfo.phone)) {
        Toast("请输入正确的手机号");
        return;
      }

      try {
        // 这里可以调用API保存用户信息
        let result = await update({
          user_name: this.userInfo.user_name,
          phone: this.userInfo.phone,
          gzh_openid: this.userInfo.gzh_openid,
          is_send: this.userInfo.is_send
        });
        if (result.code == 200) {
          Toast("保存成功");
        } else {
          Toast(result.message);
        }
      } catch (err) {
        Toast.fail("保存失败");
        console.log("保存失败:", err);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  margin: 0 auto;
  max-width: 1920px;
  padding: 10px 0 40px;
}

/* 加载状态容器 */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 60px 20px;
}

/* 刷新按钮区域 */
.refresh-section {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
}

.refresh-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: linear-gradient(135deg, #34acf3 0%, #1e88e5 100%);
  color: #fff;
  padding: 10px 16px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 0 4px 12px rgba(52, 172, 243, 0.3);
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(52, 172, 243, 0.4);
  }

  &:active {
    transform: translateY(1px) scale(0.98);
    box-shadow: 0 2px 6px rgba(52, 172, 243, 0.4);
    background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  }

  .refresh-icon {
    font-size: 16px;
    animation: rotateIcon 2s linear infinite paused;
  }

  &:active .refresh-icon {
    animation-play-state: running;
  }
}

@keyframes rotateIcon {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.aside_box {
  width: 90%;
  min-height: 360px;
  overflow: hidden;
  margin: 0 auto 40px;
  text-align: center;

  .title {
    h1 {
      font-size: 20px;
      color: #34acf3;
      font-weight: 500;
      line-height: 40px;
      letter-spacing: 2px;
      text-shadow: 0 2px 4px rgba(52, 172, 243, 0.1);
    }

    p {
      color: #545454;
      font-size: 16px;
      letter-spacing: 1px;
    }
    .qr-code-text {
      font-size: 12px;
      color: #545454;
    }
  }
}

/* 二维码动画容器 */
.qr-code-container {
  position: relative;
  display: block;
  margin: 20px auto;
  padding: 15px;
  background: linear-gradient(135deg, #fff 0%, #f0f9ff 100%);
  border-radius: 20px;
  box-shadow: 0 8px 25px rgba(52, 172, 243, 0.15);
  border: 2px solid rgba(52, 172, 243, 0.1);
  width: fit-content;
}

.img-box {
  width: 200px;
  height: 200px;
  display: block;
  border-radius: 15px;
  position: relative;
  z-index: 2;
}

/* 二维码呼吸动画 */
.animated-qr {
  animation: qrBreathing 3s ease-in-out infinite;
}

@keyframes qrBreathing {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 4px 12px rgba(52, 172, 243, 0.2);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 8px 20px rgba(52, 172, 243, 0.3);
  }
}

/* 扫描线动画 */
// .scan-line {
//   position: absolute;
//   top: 15px;
//   left: 15px;
//   right: 15px;
//   height: 2px;
//   background: linear-gradient(
//     90deg,
//     transparent 0%,
//     #ff3e4f 50%,
//     transparent 100%
//   );
//   animation: scanAnimation 2s linear infinite;
//   z-index: 3;
//   border-radius: 1px;
// }

// @keyframes scanAnimation {
//   0% {
//     top: 15px;
//     opacity: 1;
//   }
//   50% {
//     opacity: 0.7;
//   }
//   100% {
//     top: 215px;
//     opacity: 1;
//   }
// }

/* 关注状态样式 */
.status-wrapper {
  display: flex;
  align-items: center;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;

  &.subscribed {
    background: linear-gradient(135deg, #e6f3ff 0%, #f0f9ff 100%);
    border: 2px solid #34acf3;
    color: #1e88e5;

    .status-icon {
      background: #34acf3;
      color: white;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      animation: successPulse 2s ease-in-out infinite;
    }
  }

  &.unsubscribed {
    background: linear-gradient(135deg, #fef2f2 0%, #fff5f5 100%);
    border: 2px solid #f97316;
    color: #ea580c;
    cursor: pointer;
    position: relative;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(249, 115, 22, 0.2);
    }

    &:active {
      transform: translateY(1px) scale(0.98);
    }

    .status-icon {
      background: #f97316;
      color: white;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      animation: warningPulse 2s ease-in-out infinite;
    }
  }
}

@keyframes successPulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(52, 172, 243, 0.4);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 0 0 4px rgba(52, 172, 243, 0.1);
  }
}

@keyframes warningPulse {
  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(249, 115, 22, 0.4);
  }
  50% {
    transform: scale(1.1);
    box-shadow: 0 0 0 4px rgba(249, 115, 22, 0.1);
  }
}

/* 用户信息完善区域 */
.user-info-section {
  width: 80%;
  margin: 0px auto 0;
  padding: 20px;
  background: linear-gradient(135deg, #fff 0%, #f0f9ff 100%);
  border-radius: 15px;
  box-shadow: 0 6px 20px rgba(52, 172, 243, 0.1);
  border: 1px solid rgba(52, 172, 243, 0.1);
}

.section-title {
  text-align: center;
  margin-bottom: 25px;

  h2 {
    color: #34acf3;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 8px;
    letter-spacing: 1px;
  }

  p {
    color: #666;
    font-size: 14px;
    margin: 0;
  }
}

.form-container {
  max-width: 400px;
  margin: 0 auto;
}

.form-item {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  color: #333;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  padding-left: 5px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* 开关样式 */
.switch-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background: #fff;
  border-radius: 12px;
  border: 2px solid #f0f0f0;
  transition: all 0.3s ease;

  &:hover {
    border-color: #34acf3;
    box-shadow: 0 0 0 3px rgba(52, 172, 243, 0.1);
  }
}

.switch-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.switch-text {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}

.switch-desc {
  font-size: 12px;
  color: #999;
}

.custom-switch {
  position: relative;
  width: 50px;
  height: 28px;
  background: #dcdee0;
  border-radius: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &.is-active {
    background: linear-gradient(135deg, #34acf3 0%, #1e88e5 100%);

    .switch-button {
      transform: translateX(22px);
    }
  }

  .switch-button {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 24px;
    height: 24px;
    background: #fff;
    border-radius: 50%;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  &:active .switch-button {
    width: 28px;
  }
}

.form-input {
  flex: 1;
  border: 2px solid #f0f0f0;
  color: #333;
  font-size: 16px;
  height: 48px;
  padding: 0 15px;
  border-radius: 12px;
  transition: all 0.3s ease;
  background: #fff;

  &:focus {
    outline: none;
    border-color: #34acf3;
    box-shadow: 0 0 0 3px rgba(52, 172, 243, 0.1);
  }

  &::placeholder {
    color: #999;
  }

  &[readonly] {
    background: #f8f8f8;
    color: #666;
  }
}

.copy-btn {
  background: linear-gradient(135deg, #34acf3 0%, #1e88e5 100%);
  color: #fff;
  padding: 0 16px;
  border: none;
  font-size: 14px;
  font-weight: 500;
  height: 48px;
  min-width: 70px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 0 4px 12px rgba(52, 172, 243, 0.3);
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(52, 172, 243, 0.4);
  }

  &:active {
    transform: translateY(1px) scale(0.98);
    box-shadow: 0 2px 6px rgba(52, 172, 243, 0.4);
    background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(52, 172, 243, 0.3);
  }
}

.button-group {
  margin-top: 30px;
  text-align: center;
}

.save-btn {
  background: linear-gradient(135deg, #34acf3 0%, #1e88e5 100%);
  color: #fff;
  padding: 14px 40px;
  border: none;
  font-size: 16px;
  font-weight: 600;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: 0 6px 20px rgba(52, 172, 243, 0.3);
  letter-spacing: 1px;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(52, 172, 243, 0.4);
  }

  &:active {
    transform: translateY(1px) scale(0.97);
    box-shadow: 0 3px 10px rgba(52, 172, 243, 0.4);
    background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(52, 172, 243, 0.3);
  }
}

/* 底部 */
footer {
  padding: 100px 0 30px 0;
  text-align: center;
  line-height: 30px;

  div {
    padding-top: 30px;
    margin: 0 auto;
    width: 80%;
    border-top: 1px dotted rgba(52, 172, 243, 0.3);
    color: #a9a9a9;
    font-size: 8px;
  }
}
</style>
